<div class="content-card">
  <form [formGroup]="basicInformationStepFormGroup">
    <h2 class="content-card__header">{{ 'AEF-BasicInformation' | translate }}</h2>
    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Company' | translate }}</mat-label>
          <mat-select [disabled]="this.isExtension" formControlName="company">
            @for (company of listOfCompanies$ | async; track company) {
            <mat-option #matOption [value]="company.Id">{{ company.Name
              | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Employer' | translate }}</mat-label>
          <mat-select formControlName="employer" #employerSelect>
            @for (employer of listOfEmployers$ | async; track employer) {
            <mat-option #matOption [value]="employer.Id">{{
              employer.Name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
          <input #employerObjectInput matInput formControlName="employerObject"
            placeholder="{{ 'EmployerObject' | translate }}" [matAutocomplete]="autocompleteEmployerObject" />
          <mat-icon matSuffix [matTooltip]="'EmployerObjectFilterHint' | translate" matTooltipPosition="above">info</mat-icon>
          <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
            @if (isEmployerObjectsLoading) {
            <mat-option disabled>{{ 'Loading' | translate }}</mat-option>
            }
            @for (employerObject of listOfEmployerObjects$ | async; track employerObject) {
            <mat-option [value]="employerObject">
              {{ employerObject.Name }}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    @if (hasAccessToSupervisorJobTitle$ | async) {
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'SupervisorJobTitle' | translate }}</mat-label>
            <mat-select formControlName="supervisorJobTitle">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="supervisorJobTitleFilterCtrl"
                  [placeholderLabel]="'Search' | translate"
                  [noEntriesFoundLabel]="'SearchingNoResult' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              @for (supervisorJobTitle of filteredSupervisorJobTitles$ | async; track $index) {
                <mat-option #matOption [value]="supervisorJobTitle.Id">
                  {{ supervisorJobTitle.Name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }

    @if (orderItemActive && hasAssignOrderItemPermission) {
    <div class="row">
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'OrderItem' | translate }}</mat-label>
          <mat-select formControlName="orderItem">
            @for (item of listOfAvailableOrderItems$ | async; track item) {
            <mat-option #matOption [value]="item">{{ item.Name }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Location' | translate }}</mat-label>
          <input matInput formControlName="location" placeholder="{{ 'Location' | translate }}"
            [matAutocomplete]="autocompleteLocation" />
          <mat-autocomplete #autocompleteLocation="matAutocomplete" [displayWith]="displayValue">
            @for (location of listOfLocations$ | async; track location) {
            <mat-option [value]="location">
              {{ location.Name }}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'MPK' | translate }}</mat-label>
          <input matInput placeholder="{{ 'MPK' | translate }}" formControlName="mpk" autocomplete="given-name" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Workplace' | translate }}</mat-label>
          <input matInput formControlName="temporaryWorkplace" placeholder="{{ 'Workplace' | translate }}"
            [matAutocomplete]="autocompleteTemporaryWorkplace" />
          <mat-autocomplete #autocompleteTemporaryWorkplace="matAutocomplete" [displayWith]="displayValue">
            @for (temporaryWorkplace of listOfTemporaryWorkplaces$ | async; track temporaryWorkplace) {
            <mat-option [value]="temporaryWorkplace">
              {{ temporaryWorkplace.Name }}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field *hasPermissionToModule="moduleNames.Supervisors" appearance="outline">
          <mat-label>{{ 'Supervisor' | translate }}</mat-label>
          <input matInput formControlName="supervisor" placeholder="{{ 'Supervisor' | translate }}"
            [matAutocomplete]="autocompleteSupervisor" />
          <mat-autocomplete #autocompleteSupervisor="matAutocomplete" [displayWith]="displayValue">
            @for (supervisor of listOfSupervisors$ | async; track supervisor) {
            <mat-option [value]="supervisor">
              {{ supervisor.Name }}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    @if (recruiterModuleEnabled && recruiterIdActive) {
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AW-RecruiterID' | translate }}</mat-label>
          <mat-select formControlName="recruiter">
            @for (recruiter of listOfRecruiters$ | async; track recruiter) {
            <mat-option #matOption [value]="recruiter.Id">{{ recruiter.Name }}</mat-option>
            }
          </mat-select>
          @if (recruiter.hasError('required') && recruiter.touched) {
          <mat-error>
            {{ 'InvalidFieldSelect' | translate }}
          </mat-error>
          }
          @if (recruiter.invalid && recruiter.touched && !recruiter.hasError('required')) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    }

    <h2 class="content-card__header">{{ 'AgreementType' | translate }}</h2>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AgreementType' | translate }}</mat-label>
          <mat-select formControlName="agreementType">
            @for (agreementType of listOfAgreementTypes$ | async; track agreementType) {
            <mat-option [value]="agreementType.Id">
              {{ agreementType.Name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AgreementConclusionDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickConclusionDate" formControlName="conclusionDate" />
          <mat-datepicker-toggle matSuffix [for]="pickConclusionDate"></mat-datepicker-toggle>
          <mat-datepicker #pickConclusionDate></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmploymentDateFrom' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickEmploymentDateFrom" formControlName="employmentDateFrom"
            [matDatepickerFilter]="employmentDateFromFilter" (dateChange)="checkDays('change', $event)" required />
          <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateFrom"></mat-datepicker-toggle>
          <mat-datepicker #pickEmploymentDateFrom></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmploymentDateTo' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickEmploymentDateTo" formControlName="employmentDateTo"
            [matDatepickerFilter]="employmentDateToFilter" (dateChange)="checkDays('change', $event)" />
          <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateTo"></mat-datepicker-toggle>
          <mat-datepicker #pickEmploymentDateTo></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    @if (isPlannedPeriodSectionVisible) {
      <h2 class="content-card__header">{{ 'AEF-PlannedNextContractPeriod' | translate }}</h2>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AEF-AgreementDurationValue' | translate }} ({{ nextContractDurationValueMin }}-{{ nextContractDurationValueMax }})</mat-label>
            <input matInput appNumbersOnly type="number" inputmode="numeric" step="1" [min]="nextContractDurationValueMin" [max]="nextContractDurationValueMax" formControlName="contractDurationValue" required />
            @if (contractDurationValue.hasError('required') && contractDurationValue.touched) {
              <mat-error>
                {{ 'RequiredField' | translate }}
              </mat-error>
            }
            @if (hasContractDurationValueValidationError) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AEF-AgreementDurationUnit' | translate }}</mat-label>
            <mat-select formControlName="contractDurationUnit" required>
              @for (unit of contractDurationUnits; track unit) {
              <mat-option [value]="unit">
                {{ (unit === contractDurationUnitEnum.Month ? 'AEF-AgreementDurationMonth' : 'AEF-AgreementDurationYear') | translate:{ count: contractDurationValue.value || 1 } }}
              </mat-option>
              }
            </mat-select>
            @if (contractDurationUnit.hasError('required') && contractDurationUnit.touched) {
              <mat-error>
                {{ 'InvalidFieldSelect' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline" (click)="onOrganizationalUnitClick()">
          <mat-label>{{ 'OrganizationalUnit' | translate }}</mat-label>
          <input matInput formControlName="organizationalUnit" [matAutocomplete]="autocompleteOrganizationalUnit"
            maxlength="0" />
          <mat-icon matSuffix>{{ 'expand_more' }}</mat-icon>
          <mat-autocomplete #autocompleteOrganizationalUnit="matAutocomplete" [displayWith]="displayValue">
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'JobTitle' | translate }}</mat-label>
          <mat-select formControlName="jobTitle">
            <mat-option>
              <ngx-mat-select-search [formControl]="jobTitleFilterCtrl" [placeholderLabel]="'Search' | translate"
                [noEntriesFoundLabel]="'SearchingNoResult' | translate"></ngx-mat-select-search>
            </mat-option>
            @for (jobTitle of filteredJobTitles$ | async; track jobTitle) {
            <mat-option #matOption [value]="jobTitle.Id">{{ jobTitle.Name | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <app-responsibility-multi-select [control]="responsibilities"
          [filteredResponsibilities$]="filteredResponsibilities$" (filterChanged)="filterSubject.next($event)">
        </app-responsibility-multi-select>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <button class="float-right" mat-raised-button color="primary" (click)="submit()" matStepperNext>{{ 'Next' |
          translate }}</button>
      </div>
    </div>
  </form>
</div>
